module.exports = __webpack_public_path__ + "img/2025-03-11-02-02.d5e67ff0.png";